import React from 'react'
import FeatherIcon from 'feather-icons-react';
import { Dropdown } from 'react-bootstrap';
import LoadingSkeleton from '../LoadingSkeleton';
import { Link } from 'react-router-dom';
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl';

export default function ProductFilterView(props) {
    const { productFilters, loading, updateProductFilters_ } = props

    // store url
    const [storeUrl] = useStoreUrl()

    return (
        <React.Fragment>
            {loading ? <LoadingSkeleton
                productFilters={productFilters}
            />
                : (Array.isArray(productFilters) && productFilters.filter(e => e.default === "1").map((e, index) =>
                    <div className="app-card mb-3 mb-lg-4" key={index}>
                        <div className={`product-filter-card ${e.enable === "0" ? "disabled-criteria" : ""}`}>
                            <div className="card-content">
                                <div className="d-flex align-items-center">
                                    <div className="card-icon" >
                                        <span className="icon_">
                                            <FeatherIcon
                                                icon="slash"
                                                size="40"
                                                className={`icon me-2 ${e.enable === "0" ? "" : "text-primary"}`} />
                                        </span>
                                    </div>
                                    <div className="card-text">
                                        <div className="card-header_">
                                            <span>{e.name}</span>
                                        </div>
                                        <div className="card-description">
                                            <div>Checkbox to show only products that are in stock.</div>
                                            <span className={`description ${e.enable === "0" ? "" : "text-warning st-fw-600"}`}>You have 11488 in stock and 545 out of stock products</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex">
                                    <Dropdown className="st-bs-dropdown no-down-icon action-btn me-4"
                                        id={e.name}
                                    >
                                        <Dropdown.Toggle className="st-btn st-btn-white-gray-outlined st-btn-sm  align-items-center justify-content-center align-items-center">
                                            <span>Actions</span>
                                            <FeatherIcon
                                                icon="chevron-down"
                                                size="15"
                                                className="icon ms-1" />
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                            <Link to={storeUrl + "/settings/product-filters/sort-product-filters"} className="text-decoration-none text-currentcolor">
                                                <label className="dropdown-item st-checkbox d-inline-flex cursor-pointer">
                                                    <input
                                                        type="checkbox"
                                                        className="d-none"
                                                    />
                                                    <span className="text ms-2">Sort
                                                    </span>
                                                </label>
                                            </Link>
                                            <Dropdown.Item className="dropdown-item st-checkbox d-inline-flex cursor-pointer"
                                                onClick={e_ => {
                                                    console.log("ww")
                                                    e.default = "0"
                                                    const index_ = productFilters.findIndex(i => i.name === e.name)
                                                    productFilters[index_] = e
                                                    updateProductFilters_(productFilters)
                                                }}
                                            >
                                                {/* <input
                                                    type="checkbox"
                                                    className="d-none"
                                                    value={"d"}
                                                /> */}
                                                <span className="text ms-2">Delete</span>
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                    <div className="switch-btn">
                                        <label className="st-switch-input-xs st-switch-success d-inline-flex align-items-center">
                                            <input
                                                type="checkbox"
                                                className="d-none"
                                                name="switch"
                                                checked={(e.enable === "0") ? false : true}
                                                onChange={ev => {
                                                    e.enable = ev.target.checked ? "1" : "0"
                                                    const index_ = productFilters.findIndex(i => i.name === e.name)
                                                    productFilters[index_] = e
                                                    updateProductFilters_(productFilters)
                                                }}

                                            />
                                            <span className="round-outer">
                                                <span className="round d-block"></span>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))
            }

        </React.Fragment >
    )
}